const { makeStyles } = require('@material-ui/core')

export const useCreationStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: 0
  }
}))
